"use client";

import dynamic from "next/dynamic";

const ScreenManagementFeatures = dynamic(
  () =>
    import("./ScreenManagementFeatures").then(mod => ({
      default: mod.ScreenManagementFeatures,
    })),
  {
    loading: () => <div className="min-h-[320px] w-full animate-pulse bg-gray-50" />,
  }
);

export default ScreenManagementFeatures;
